
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tnpsc-general-enrichment-test-series",
      function () {
        return require("private-next-pages/tnpsc-general-enrichment-test-series/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tnpsc-general-enrichment-test-series"])
      });
    }
  